import { render, staticRenderFns } from "./ApplicationPage.vue?vue&type=template&id=7c35a840&scoped=true"
import script from "./ApplicationPage.vue?vue&type=script&lang=ts"
export * from "./ApplicationPage.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationPage.vue?vue&type=style&index=0&id=7c35a840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c35a840",
  null
  
)

export default component.exports